import FetchQuote from '../components/FetchQuote';

const Quote = () => (
  <div className="quote-page">
    <FetchQuote />
  </div>
);
export default Quote;
